import 'bootstrap/dist/css/bootstrap.min.css';
import Navigation from './Routes/Navigation';

function App() {
  return (
    <Navigation/>
  );
}
export default App;
